module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-header"
  }, [_c('div', {
    staticClass: "target"
  }, [_c('div', {
    staticClass: "sub-text"
  }, [_vm._v("Our target")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.targetText))])]), _vm._v(" "), _c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "progress-bar-wrapper"
  }, [_c('div', {
    staticClass: "progress-bar-inner",
    style: ({
      width: 100 - _vm.percent + '%'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "edo-tree-icon",
    style: ({
      left: 'calc(' + _vm.percent + '% - (' + _vm.percent / 100 + '* 64px))',
    })
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3250/dist/assets/img/LR - Progress bar icon.svg"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "counter"
  }, [_vm._v("\n    " + _vm._s(Math.ceil(_vm.currentCounter)) + "\n  ")]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.headerText))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9b5995e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=v6bwv9n4fgn!./~/string-replace-webpack-plugin/loader.js?id=oue8yteht5p!./src/components/leaf-relief/Header.vue
// module id = 721
// module chunks = 0